module.exports = __webpack_public_path__ + "img/choose-up-cultura.a0395be4.png";